import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TEvaluation {
  id: number;
  date: Date;
  result?: string;
  reportEvaluationStatus: string;
  errorLog?: string;
}

export interface IEvaluation extends TEvaluation {}

const Evaluation = Model(
  (model: TEvaluation): IEvaluation => {
    const _evaluation: TEvaluation = Object.assign({}, model);

    let create = (evaluation: IEvaluation): IEvaluation => {
      let obj = ValidatableObject(evaluation);
      return obj;
    };

    let evaluation = {
      get id() {
        return _evaluation.id;
      },
      set id(value) {
        _evaluation.id = value;
      },
      get date() {
        return _evaluation.date;
      },
      set date(value) {
        _evaluation.date = value;
      },
      get result() {
        return _evaluation.result;
      },
      set result(value) {
        _evaluation.result = value;
      },
      get reportEvaluationStatus() {
        return _evaluation.reportEvaluationStatus;
      },
      set reportEvaluationStatus(value) {
        _evaluation.reportEvaluationStatus = value;
      },
      get errorLog() {
        return _evaluation.errorLog;
      },
      set errorLog(value) {
        _evaluation.errorLog = value;
      }
    };

    return create(evaluation);
  }
);

export default Evaluation;
